import { memo } from 'react'

import { useAnimatedPlaceholder } from 'hooks/useAnimatedPlaceholder'
import * as Styled from './styled'
import { IProps } from './types'

/**
 * Typewriter placeholder overlay for a contenteditable prompt editor (a real
 * `placeholder` attribute does not apply): cycles through the given texts with
 * a typing / pause / delete loop and a caret.
 *
 * It has NO visibility logic of its own — the caller decides when to render it.
 * AI Image renders it whenever the editor is empty; AI Video keeps its stricter
 * pre-existing gate (empty AND no project media AND unfocused).
 */
const AnimatedPlaceholder = ({ texts }: IProps) => {
  const { animatedText, isCaretBlinking } = useAnimatedPlaceholder(texts)

  return (
    <Styled.Overlay>
      <span>{animatedText}</span>
      <Styled.Caret $isBlinking={isCaretBlinking} />
    </Styled.Overlay>
  )
}

export default memo(AnimatedPlaceholder)
